/**
 * Starts `start` once no save pass is running — not just the one that was
 * running when the caller arrived.
 *
 * SCRUM-1032 round 7 review: two forced saves (Save, then Next) both awaited
 * the same pass, and both woke to start their own, writing the same rows twice
 * at once. The check and the start happen in the same tick, so the second
 * caller always sees the pass the first one just started, and waits for that
 * too. A pass that rejects still counts as finished.
 */
export const runWhenIdle = async <R>(
  inFlight: { current: Promise<unknown> | null },
  start: () => Promise<R>,
): Promise<R> => {
  while (inFlight.current) {
    try {
      await inFlight.current
    } catch {
      // Finished is finished; the pass reports its own failure.
    }
  }
  return start()
}
